import { CompetenceModel } from './competence.model';
import { OnlinetestModel } from 'projects/core/src/lib/models/onlinetest.model';
import { CandidateAcOnlinetestModel } from './candidate-ac-onlinetest.model';
import { ONLINETEST_TYPE_NAMES } from '../constants';

export enum OnlinetestTypes {
  Normal = 'normal',
  Before = 'before',
}

export class AcOnlinetestModel extends OnlinetestModel {

  // columns
  type: OnlinetestTypes;
  duration: number;
  rating_duration: number; // tslint:disable-line: variable-name
  unlock_days: number; // tslint:disable-line: variable-name
  hidden_competences: Array<CompetenceModel> = []; // tslint:disable-line: variable-name
  relevant_competences: Array<CompetenceModel> = []; // tslint:disable-line: variable-name
  misc: any;

  // relations
  candidates: Array<CandidateAcOnlinetestModel>;

  deserialize(input: any): this {
    Object.assign(this, super.deserialize(input));
    // reports
    let candidates = null;
    if (this.candidates !== null && this.candidates !== undefined) {
      candidates = [];
      this.candidates.forEach((candidate: CandidateAcOnlinetestModel) => {
        candidates.push(new CandidateAcOnlinetestModel().deserialize(candidate));
      });
    }
    this.candidates = candidates;
    // pivot
    if (this.pivot) {
      this.type = this.pivot.type;
      this.duration = this.pivot.duration;
      this.rating_duration = this.pivot.rating_duration;
      this.unlock_days = this.pivot.unlock_days;
      this.setHiddenCompetences(this.pivot?.hidden_competences);
    }
    return this;
  }

  getTypeName(): string {
    return ONLINETEST_TYPE_NAMES[this.type];
  }

  get typename_full(): string {
    if (this.type === OnlinetestTypes.Before) {
      return this.getTypeName() + ' ' + this.unlock_days + ' Tage';
    } else {
      return this.getTypeName();
    }
  }

  private setHiddenCompetences(idList: Array<number> = null): void {
    this.hidden_competences = [];
    if (idList !== null) {
      this.competences.forEach((competence: CompetenceModel) => {
        if (idList.indexOf(competence.id) !== -1) {
          this.hidden_competences.push(competence);
        } else {
          this.relevant_competences.push(competence);
        }
      });
    }
  }

}
